import React from 'react';
import { HashRouter , Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './page/home/Home';
import Login from './page/login/Login';
import DocumentTemplate from './page/template/DocumentTemplate';

function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Login route */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        
        {/* Protected Home route */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documenttemplate"
          element={
            <ProtectedRoute>
              <DocumentTemplate />
            </ProtectedRoute>
          }
        />

        {/* Catch all unmatched routes */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </HashRouter>
  );
}

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/home" replace /> : children;
};

export default App;